import Toast from 'react-bootstrap/Toast';

/**
 * Port of `commonComponents/TaskDoneWarningModel.jsx`.
 *
 * The `ref` callback that focuses the container on mount is kept — it is what moves
 * keyboard focus into the warning, and the tabIndex values around it are part of that
 * behavior. The commented-out auto-dismiss in the original's componentDidMount is not
 * carried; the toast is dismissed by the OK button or the close control.
 */
export function TaskDoneWarningModel({ taskDone }: { taskDone: (value: boolean) => void }) {
  return (
    <div
      tabIndex={0}
      ref={(inputElement) => {
        if (inputElement) {
          inputElement.focus();
        }
      }}
      className="task-done-warning"
      style={{
        backgroundColor: '#fff',
        position: 'absolute',
        top: 100,
        left: 400,
        zIndex: 9999,
        float: 'left',
        border: '2px solid #cecece',
        borderRadius: '5px',
        width: '550px',
      }}
    >
      <Toast
        tabIndex={1}
        className=""
        style={{ width: '550px' }}
        onClose={() => {
          taskDone(false);
        }}
      >
        <Toast.Header>
          <div className="warning-ico"></div>
          <strong className="me-auto" tabIndex={0}>
            {' '}
            Warning
          </strong>
        </Toast.Header>
        <Toast.Body>
          <div className="row" style={{ fontSize: '12px' }}>
            <label tabIndex={0}>
              Changing the Checkin Task status to "Done" will freeze the time entry for the
              Task.
            </label>
          </div>
          <div className="modal-footer">
            <button
              tabIndex={0}
              type="button"
              className="btn modal-button"
              onClick={() => taskDone(false)}
            >
              OK
            </button>
          </div>
        </Toast.Body>
      </Toast>
    </div>
  );
}
